<template>
  <div class="menu-wrapper">
    <el-submenu v-if="item.name && !item.hidden" :index="item.path + item.id">
      <template slot="title">
        <div @click="handleTo(item, 1)">
          <i :class="item.icon"></i>{{ item.name }}
        </div>
      </template>

      <template v-if="item.children">
        <template
          v-for="(twoMenu, index) in item.children"
          :index="twoMenu.path"
        >
          <template v-if="twoMenu.children">
            <el-submenu :index="item.path + twoMenu.path + index">
              <template slot="title">
                <div @click="handleTo(twoMenu, 22)">
                  <i :class="twoMenu.icon"></i>1{{ twoMenu.meta.title }}
                </div>
              </template>
              <template v-for="(three, i) in twoMenu.children">
                <el-menu-item
                  :index="item.path + twoMenu.path + '/' + three.path"
                >
                  <div class="btn" @click="handleTo(three, 3)">
                    <i :class="three.meta.icon"></i>1{{ three.meta.title }}
                  </div>
                </el-menu-item>
              </template>
            </el-submenu>
          </template>

          <el-menu-item v-else :index="item.path + '/' + twoMenu.path">
            <div class="btn" @click="handleTo(twoMenu, 2)">
              <i :class="twoMenu.icon"></i>{{ twoMenu.meta.title }}
            </div>
          </el-menu-item>
        </template>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { generateTitle } from '@/utils/i18n'
import { isExternal } from '@/utils/validate'

export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: '',
    },
    superiors: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      onlyOneChild: null,
    }
  },
  methods: {
    handleTo(url, type) {
      // console.log(url, type)
      switch (type) {
        case 1:
          break
        case 2:
          console.log(this.$props.superiors, url.path)
          // this.$router.push(`${this.$props.superiors}/index`)
          // this.$router.push(`${this.$props.superiors}/${url.path}`)
          break
        case 3:
          break
        case 22:
          this.$router.push(`${this.$props.superiors}/${url.redirect}`)
          break
      }
    },
    hasOneShowingChild(children, parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false
        } else {
          this.onlyOneChild = item
          return true
        }
      })

      if (showingChildren.length === 1) {
        return true
      }

      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      return path.resolve(this.basePath, routePath)
    },

    generateTitle,
  },
}
</script>
